/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Risk_Write_InternalInputs */



/**
* | output |
* | --- |
* | "Internal write" |
*
* @param {Agent_Run_Risk_Write_InternalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_risk_write_internal = /** @type {((inputs?: Agent_Run_Risk_Write_InternalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Risk_Write_InternalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Interner Schreibzugriff")
	return /** @type {LocalizedString} */ ("Internal write")
});